import { render, staticRenderFns } from "./StudyNewPageScreening.vue?vue&type=template&id=54f277ca&scoped=true"
import script from "./StudyNewPageScreening.vue?vue&type=script&lang=js"
export * from "./StudyNewPageScreening.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageScreening.vue?vue&type=style&index=0&id=54f277ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f277ca",
  null
  
)

export default component.exports